function Header() {
  return (
    <header className="site-header">
      <div className="container nav">
        <a href="#home" className="logo">
          Dylan Tomlinson
        </a>

        <nav className="nav-links">
          <a href="#about">About</a>
          <a href="#projects">Projects</a>
          <a href="#contact">Contact</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;